"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchAnalyticsQueryDto = void 0;
const cursor_pagination_1 = require("../cursor-pagination");
class SearchAnalyticsQueryDto extends cursor_pagination_1.CursorPaginationOptions {
    from;
    to;
    displayIds;
    mediaIds;
    reqIds;
    methods;
    originalUrls;
    userAgents;
    referrers;
    forwardedFors;
    ips;
    organizationNames;
    asns;
    organization;
    areaCodes;
    longitudes;
    latitudes;
    uas;
}
exports.SearchAnalyticsQueryDto = SearchAnalyticsQueryDto;
